import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import './index.css';

const MarkdownView = ({ content, disableLinks = false }) => {
  const components = disableLinks
    ? {
        // 当disableLinks为true时，自定义链接渲染器，将链接渲染为纯文本
        a: ({ children, href, ...props }) => {
          return <span style={{ color: '#24292f' }}>{children}</span>;
        },
      }
    : {
        // 链接统一在新标签页打开，避免把当前页面刷新掉
        a: ({ children, href, ...props }) => (
          <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
            {children}
          </a>
        ),
      };

  return (
    <div className="markdown-body">
      <ReactMarkdown
        children={content}
        components={components}
        rehypePlugins={[rehypeRaw]}
        remarkPlugins={[remarkGfm, { singleTilde: false }]}
      />
    </div>
  );
};

export default MarkdownView;
